<loading></loading>
<p-toast key="appraiser_toast">
  <ng-template let-message pTemplate="message">
    <div class="flex align-items-center flex-1">
      <i class="{{ message.icon }} text-2xl"></i>
      <div class="flex flex-column align-items-start ml-3">
        <div class="text-lg font-medium">
          {{ message.summary }}
        </div>
        <div *ngIf="Array.isArray(message.detail); else singleMessage">
            <div class="mt-2" *ngFor="let detailMessage of message.detail; let i = index">
              {{ i + 1 }}. {{ detailMessage }}
            </div>
        </div>
        <ng-template #singleMessage>
          <div>{{ message.detail }}</div>
        </ng-template>
      </div>
    </div>
  </ng-template>
</p-toast>
<router-outlet></router-outlet>
